var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.startList),function(i,index){return _c('img',{key:index,staticStyle:{"width":"20px","height":"20px"},style:({'cursor': _vm.isCanClick?'pointer':''}),attrs:{"src":_vm.startTotal1>index?_vm.star1:_vm.star2},on:{"click":function($event){_vm.isCanClick?_vm.clickStars(index):''}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }